import {mediaConsts} from 'santa-core-utils'

export const name = 'MediaPlayersAspect'

export const functionLibrary = {
    getIsPlaybackPlayIntent(state) {
        return state.previousPlaybackState === mediaConsts.playbackTypes.PLAYING
    }
}
